<h3 *ngIf="Headline">{{Headline}}</h3>
<div class="sub-line">
    <span *ngIf="Subline">{{Subline}}</span>
</div>
<app-doughnut-chart #chart [HideLegend]="HideLegend" [Options]="Options" [CenterTemplate]="CenterTemplate" [Datasets]="Datasets" [Labels]="Labels" (CenterClick)="OpenMeInPopUp()"></app-doughnut-chart>
<mat-dialog-actions *ngIf="DialogData">
    <button app-button mat-dialog-close="">Schließen</button>
</mat-dialog-actions>
